import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { Family } from 'src/clients/hooks/useFamily';
import DrawerFlow, { DrawerFlowStep } from 'src/UI/drawer-flow/DrawerFlow';
import SelectClientOrFamilyStep from 'src/UI/drawer-flow/SelectClientOrFamilyStep';
import { Client } from 'src/users';
import DataExportProgressSvg from './assets/data-export-progress.svg?react';
import GenerateOptionsStep from 'src/data-export/steps/GenerateOptionsStep';

type DataExportFlowProps = {
  opened: boolean;
  close: () => void;
};

type DataExportData = {
  client?: Client;
  family?: Family;
  selectionType?: 'client' | 'family';
  includeSensitiveFields?: boolean;
  configId?: string;
};

const initialData: DataExportData = {
  client: undefined,
  family: undefined,
  selectionType: 'client',
  includeSensitiveFields: false,
};

const steps: DrawerFlowStep<DataExportData>[] = [
  {
    title: 'Select client or family',
    showClientName: false,
    screens: [
      {
        component: SelectClientOrFamilyStep,
        renderProgress: () => <DataExportProgressSvg />,
      },
    ],
  },
  {
    title: 'Generate data export',
    showClientName: true,
    screens: [
      {
        component: GenerateOptionsStep,
        renderProgress: () => <DataExportProgressSvg />,
      },
    ],
  },
];

export default function DataExportFlow({ opened, close }: DataExportFlowProps) {
  const [data, setData] = useState<DataExportData>(initialData);
  const navigate = useNavigate();

  const onSuccess = useCallback(
    (data: DataExportData) => {
      if (data.selectionType === 'client' && data.client) {
        navigate(`/client/${data.client.id}/document/data-exports`);
      } else if (data.selectionType === 'family' && data.family) {
        navigate(`/client/${data.family.mainFamilyMember.clientId}/document/data-exports`);
      }
    },
    [navigate],
  );

  return (
    <DrawerFlow
      opened={opened}
      close={close}
      title="Data export"
      steps={steps}
      initialData={initialData}
      data={data}
      setData={setData}
      onSuccess={onSuccess}
    />
  );
}
